<template>
  <div class="mb-32 max-w-352">
    <h2 class="text-h3 mb-16">In progress</h2>
    <router-link :to="$store.getters['adventures/resumePath']" class="block primary-focus" alt="Edit Draft">
      <Card>
        <AlertBanner :status="0" class="rounded-t-lg"> Your draft will expire {{ daysToExpiration }} </AlertBanner>
        <div class="flex justify-between gap-8 m-16">
          <div class="min-w-0">
            <h2
              class="adventure-card-title text-strong-body mb-4 text-ellipsis overflow-hidden break-words text-grey-text-subdued"
              style="-webkit-line-clamp: 2"
            >
              {{ `${draftAdventure.adventureCategoryName} Adventure` }}
            </h2>
            <div class="truncate">
              <p class="text-small inline text-grey-text-subdued">
                {{ `Last edited on ${lastEditedDate}` }}
              </p>
            </div>
          </div>
          <JobsIcon class="ml-auto my-auto inline" />
        </div>
      </Card>
    </router-link>
  </div>
</template>

<script lang="ts">
import { parseISO, format, formatDistanceToNow, addDays } from 'date-fns';
import Card from '@/components/card/Card.vue';
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';
import JobsIcon from '@/graphics/icons/JobsIcon.vue';

export default {
  name: 'Draft',
  components: { Card, JobsIcon, AlertBanner },
  props: {
    hasSitterProfile: {
      type: Boolean,
      default: false,
    },
    draftAdventure: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    lastEditedDate(): String {
      const d = parseISO(this.draftAdventure.updatedAt);
      return format(d, 'MMM d');
    },
    daysToExpiration(): String {
      const draftedAt = parseISO(this.draftAdventure.draftedAt);
      const expiry = addDays(draftedAt, 7);

      // output is a human readable string. E.g. "in 6 days"
      return formatDistanceToNow(expiry, { addSuffix: true });
    },
  },
};
</script>

<style scoped>
.card {
  padding: 0 0 1rem;
}
</style>
